export function isTelegramWebApp() {
    // @ts-ignore
    return typeof TelegramWebviewProxy !== 'undefined'
}

export async function canBufferImages() {
    const isPermissionGranted = await askWritePermission()
    return (
        typeof navigator !== 'undefined' &&
        !!window.ClipboardItem &&
        typeof ClipboardItem !== 'undefined' &&
        typeof navigator.clipboard.write === 'function' &&
        isPermissionGranted &&
        !isTelegramWebApp()
    )
}

async function askWritePermission() {
    try {
        // The clipboard-write permission is granted automatically to pages
        // when they are the active tab. So it's not required, but it's more safe.
        const { state } = await navigator.permissions.query({
            name: 'clipboard-write' as PermissionName,
        })
        return state === 'granted'
    } catch (error) {
        // Browser compatibility / Security error (ONLY HTTPS) ...
        return false
    }
}
